/*!
 * Application Insights JavaScript SDK - Core, 2.0.0
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
!function (e, i) {
  "object" == typeof exports && "undefined" != typeof module ? i(exports) : "function" == typeof define && define.amd ? define(["exports"], i) : i((e.Microsoft = e.Microsoft || {}, e.Microsoft.ApplicationInsights = {}));
}(this, function (a) {
  "use strict";

  var i = {
    Unknown: 0,
    NonRetryableStatus: 1,
    InvalidEvent: 2,
    SizeLimitExceeded: 3,
    KillSwitch: 4,
    QueueFull: 5
  },
      f = (e.isNullOrUndefined = function (e) {
    return null == e;
  }, e.disableCookies = function () {
    e._canUseCookies = !1;
  }, e.newGuid = function () {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(n, function (e) {
      var i = 16 * Math.random() | 0;
      return ("x" === e ? i : 3 & i | 8).toString(16);
    });
  }, e);

  function e() {}

  var t,
      n = /[xy]/g,
      g = (o.prototype.addNotificationListener = function (e) {
    this.listeners.push(e);
  }, o.prototype.removeNotificationListener = function (e) {
    for (var i = this.listeners.indexOf(e); -1 < i;) {
      this.listeners.splice(i, 1), i = this.listeners.indexOf(e);
    }
  }, o.prototype.eventsSent = function (i) {
    for (var t = this, e = function e(_e) {
      n.listeners[_e].eventsSent && setTimeout(function () {
        return t.listeners[_e].eventsSent(i);
      }, 0);
    }, n = this, o = 0; o < this.listeners.length; ++o) {
      e(o);
    }
  }, o.prototype.eventsDiscarded = function (i, t) {
    for (var n = this, e = function e(_e2) {
      o.listeners[_e2].eventsDiscarded && setTimeout(function () {
        return n.listeners[_e2].eventsDiscarded(i, t);
      }, 0);
    }, o = this, r = 0; r < this.listeners.length; ++r) {
      e(r);
    }
  }, o);

  function o() {
    this.listeners = [];
  }

  (t = a.LoggingSeverity || (a.LoggingSeverity = {}))[t.CRITICAL = 1] = "CRITICAL", t[t.WARNING = 2] = "WARNING";
  var s = {
    BrowserDoesNotSupportLocalStorage: 0,
    BrowserCannotReadLocalStorage: 1,
    BrowserCannotReadSessionStorage: 2,
    BrowserCannotWriteLocalStorage: 3,
    BrowserCannotWriteSessionStorage: 4,
    BrowserFailedRemovalFromLocalStorage: 5,
    BrowserFailedRemovalFromSessionStorage: 6,
    CannotSendEmptyTelemetry: 7,
    ClientPerformanceMathError: 8,
    ErrorParsingAISessionCookie: 9,
    ErrorPVCalc: 10,
    ExceptionWhileLoggingError: 11,
    FailedAddingTelemetryToBuffer: 12,
    FailedMonitorAjaxAbort: 13,
    FailedMonitorAjaxDur: 14,
    FailedMonitorAjaxOpen: 15,
    FailedMonitorAjaxRSC: 16,
    FailedMonitorAjaxSend: 17,
    FailedMonitorAjaxGetCorrelationHeader: 18,
    FailedToAddHandlerForOnBeforeUnload: 19,
    FailedToSendQueuedTelemetry: 20,
    FailedToReportDataLoss: 21,
    FlushFailed: 22,
    MessageLimitPerPVExceeded: 23,
    MissingRequiredFieldSpecification: 24,
    NavigationTimingNotSupported: 25,
    OnError: 26,
    SessionRenewalDateIsZero: 27,
    SenderNotInitialized: 28,
    StartTrackEventFailed: 29,
    StopTrackEventFailed: 30,
    StartTrackFailed: 31,
    StopTrackFailed: 32,
    TelemetrySampledAndNotSent: 33,
    TrackEventFailed: 34,
    TrackExceptionFailed: 35,
    TrackMetricFailed: 36,
    TrackPVFailed: 37,
    TrackPVFailedCalc: 38,
    TrackTraceFailed: 39,
    TransmissionFailed: 40,
    FailedToSetStorageBuffer: 41,
    FailedToRestoreStorageBuffer: 42,
    InvalidBackendResponse: 43,
    FailedToFixDepricatedValues: 44,
    InvalidDurationValue: 45,
    TelemetryEnvelopeInvalid: 46,
    CreateEnvelopeError: 47,
    CannotSerializeObject: 48,
    CannotSerializeObjectNonSerializable: 49,
    CircularReferenceDetected: 50,
    ClearAuthContextFailed: 51,
    ExceptionTruncated: 52,
    IllegalCharsInName: 53,
    ItemNotInArray: 54,
    MaxAjaxPerPVExceeded: 55,
    MessageTruncated: 56,
    NameTooLong: 57,
    SampleRateOutOfRange: 58,
    SetAuthContextFailed: 59,
    SetAuthContextFailedAccountName: 60,
    StringValueTooLong: 61,
    StartCalledMoreThanOnce: 62,
    StopCalledWithoutStart: 63,
    TelemetryInitializerFailed: 64,
    TrackArgumentsNotSpecified: 65,
    UrlTooLong: 66,
    SessionStorageBufferFull: 67,
    CannotAccessCookie: 68,
    IdTooLong: 69
  },
      l = (r.sanitizeDiagnosticText = function (e) {
    return '"' + e.replace(/\"/g, "") + '"';
  }, r.dataType = "MessageData", r.AiNonUserActionablePrefix = "AI (Internal): ", r.AiUserActionablePrefix = "AI: ", r);

  function r(e, i, t, n) {
    void 0 === t && (t = !1), this.messageId = e, this.message = (t ? r.AiUserActionablePrefix : r.AiNonUserActionablePrefix) + e;
    var o = (i ? " message:" + r.sanitizeDiagnosticText(i) : "") + (n ? " props:" + r.sanitizeDiagnosticText(JSON.stringify(n)) : "");
    this.message += o;
  }

  var u = (c.prototype.throwInternal = function (e, i, t, n, o) {
    void 0 === o && (o = !1);
    var r = new l(i, t, o, n);
    if (this.enableDebugExceptions()) throw r;

    if (void 0 !== r && r && void 0 !== r.message) {
      if (o) {
        var s = +r.messageId;
        (!this._messageLogged[s] || this.consoleLoggingLevel() >= a.LoggingSeverity.WARNING) && (this.warnToConsole(r.message), this._messageLogged[s] = !0);
      } else this.consoleLoggingLevel() >= a.LoggingSeverity.WARNING && this.warnToConsole(r.message);

      this.logInternalMessage(e, r);
    }
  }, c.prototype.warnToConsole = function (e) {
    "undefined" != typeof console && console && ("function" == typeof console.warn ? console.warn(e) : "function" == typeof console.log && console.log(e));
  }, c.prototype.resetInternalMessageCount = function () {
    this._messageCount = 0, this._messageLogged = {};
  }, c.prototype.logInternalMessage = function (e, i) {
    if (!this._areInternalMessagesThrottled()) {
      var t = !0,
          n = this.AIInternalMessagePrefix + i.messageId;

      if (this._messageLogged[n] ? t = !1 : this._messageLogged[n] = !0, t && (e <= this.telemetryLoggingLevel() && (this.queue.push(i), this._messageCount++), this._messageCount == this.maxInternalMessageLimit())) {
        var o = "Internal events throttle limit per PageView reached for this app.",
            r = new l(s.MessageLimitPerPVExceeded, o, !1);
        this.queue.push(r), this.warnToConsole(o);
      }
    }
  }, c.prototype._areInternalMessagesThrottled = function () {
    return this._messageCount >= this.maxInternalMessageLimit();
  }, c);

  function c(e) {
    this.AIInternalMessagePrefix = "AITR_", this.enableDebugExceptions = function () {
      return !1;
    }, this.consoleLoggingLevel = function () {
      return 1;
    }, this.telemetryLoggingLevel = function () {
      return 0;
    }, this.maxInternalMessageLimit = function () {
      return 25;
    }, this.queue = [], this._messageCount = 0, this._messageLogged = {}, f.isNullOrUndefined(e) || (f.isNullOrUndefined(e.loggingLevelConsole) || (this.consoleLoggingLevel = function () {
      return e.loggingLevelConsole;
    }), f.isNullOrUndefined(e.loggingLevelTelemetry) || (this.telemetryLoggingLevel = function () {
      return e.loggingLevelTelemetry;
    }), f.isNullOrUndefined(e.maxMessageLimit) || (this.maxInternalMessageLimit = function () {
      return e.maxMessageLimit;
    }), f.isNullOrUndefined(e.enableDebugExceptions) || (this.enableDebugExceptions = function () {
      return e.enableDebugExceptions;
    }));
  }

  var d = (h.prototype.initialize = function (e, i) {
    var t = this;
    if (this._isInitialized) throw Error("Core should not be initialized more than once");
    if (!e || f.isNullOrUndefined(e.instrumentationKey)) throw Error("Please provide instrumentation key");

    if (this.config = e, this._notificationManager = new g(), this.config.extensions = f.isNullOrUndefined(this.config.extensions) ? [] : this.config.extensions, this.config.extensionConfig = f.isNullOrUndefined(this.config.extensionConfig) ? {} : this.config.extensionConfig, this.config.extensionConfig.NotificationManager = this._notificationManager, this.logger = new u(e), i.forEach(function (e) {
      if (f.isNullOrUndefined(e.initialize)) throw Error(v);
    }), 0 < this.config.extensions.length) {
      var n = !0,
          o = !1;
      if (this.config.extensions.forEach(function (e) {
        f.isNullOrUndefined(e) && (n = !1), e.priority > m && (o = !0);
      }), !n) throw Error(v);
      if (o) throw Error(y);
    }

    (s = this._extensions).push.apply(s, [this._channelController].concat(i, this.config.extensions)), this._extensions = this._extensions.sort(function (e, i) {
      var t = e,
          n = i,
          o = typeof t.processTelemetry,
          r = typeof n.processTelemetry;
      return "function" == o && "function" == r ? t.priority - n.priority : "function" == o && "function" != r ? 1 : "function" != o && "function" == r ? -1 : void 0;
    });
    var r = {};

    this._extensions.forEach(function (e) {
      var i = e;
      i && i.priority && (f.isNullOrUndefined(r[i.priority]) ? r[i.priority] = i.identifier : t.logger.warnToConsole("Two extensions have same priority" + r[i.priority] + ", " + i.identifier));
    });

    for (var s, a = -1, l = 0; l < this._extensions.length - 1; l++) {
      var c = this._extensions[l];

      if (!c || "function" == typeof c.processTelemetry) {
        if (c.priority === m) {
          a = l + 1;
          break;
        }

        this._extensions[l].setNextPlugin(this._extensions[l + 1]);
      }
    }

    if (this._channelController.initialize(this.config, this, this._extensions), this._extensions.forEach(function (e) {
      e && e.priority < m && e.initialize(t.config, t, t._extensions);
    }), a < this._extensions.length && this._extensions.splice(a), 0 === this.getTransmissionControls().length) throw new Error("No channels available");
    this._isInitialized = !0;
  }, h.prototype.getTransmissionControls = function () {
    return this._channelController.ChannelControls;
  }, h.prototype.track = function (e) {
    if (null === e) throw this._notifiyInvalidEvent(e), Error("Invalid telemetry item");
    if (e.baseData && !e.baseType) throw this._notifiyInvalidEvent(e), Error("Provide data.baseType for data.baseData");
    e.baseType || (e.baseType = "EventData"), e.iKey || (e.iKey = this.config.instrumentationKey), e.time || (e.time = new Date().toISOString()), f.isNullOrUndefined(e.ver) && (e.ver = "4.0"), this._validateTelmetryItem(e), this._updateSdkVersion(e);

    for (var i = 0; i < this._extensions.length;) {
      if (this._extensions[i].processTelemetry) {
        this._extensions[i].processTelemetry(e);

        break;
      }

      i++;
    }
  }, h.prototype.addNotificationListener = function (e) {
    this._notificationManager.addNotificationListener(e);
  }, h.prototype.removeNotificationListener = function (e) {
    this._notificationManager.removeNotificationListener(e);
  }, h.prototype.pollInternalLogs = function () {
    var t = this,
        e = this.config.diagnosticLogInterval;
    return 0 < e || (e = 1e4), setInterval(function () {
      var e = t.logger.queue;
      e.forEach(function (e) {
        var i = {
          name: "InternalMessageId: " + e.messageId,
          iKey: t.config.instrumentationKey,
          time: new Date().toISOString(),
          baseType: l.dataType,
          baseData: {
            message: e.message
          }
        };
        t.track(i);
      }), e.length = 0;
    }, e);
  }, h.prototype._validateTelmetryItem = function (e) {
    if (f.isNullOrUndefined(e.name)) throw this._notifiyInvalidEvent(e), Error("telemetry name required");
    if (f.isNullOrUndefined(e.time)) throw this._notifiyInvalidEvent(e), Error("telemetry timestamp required");
    if (f.isNullOrUndefined(e.iKey)) throw this._notifiyInvalidEvent(e), Error("telemetry instrumentationKey required");
  }, h.prototype._updateSdkVersion = function (e) {
    e.ext || (e.ext = {}), e.ext.sdk || (e.ext.sdk = {});

    for (var i = "", t = 0; t < this._extensions.length; t++) {
      var n = this._extensions[t];

      if (n.identifier && n.version) {
        var o = n.identifier + ":" + n.version + ";";
        i = i.concat(o);
      }
    }

    "" != i && (e.ext.sdk.libVer = i);
  }, h.prototype._notifiyInvalidEvent = function (e) {
    this._notificationManager.eventsDiscarded([e], i.InvalidEvent);
  }, h);

  function h() {
    this._isInitialized = !1, this._extensions = new Array(), this._channelController = new p();
  }

  var p = (x.prototype.processTelemetry = function (i) {
    this.channelQueue.forEach(function (e) {
      0 < e.length && e[0].processTelemetry(i);
    });
  }, Object.defineProperty(x.prototype, "ChannelControls", {
    get: function get() {
      return this.channelQueue;
    },
    enumerable: !0,
    configurable: !0
  }), x.prototype.initialize = function (t, n, o) {
    var r = this;

    if (t.isCookieUseDisabled && f.disableCookies(), this.channelQueue = new Array(), t.channels) {
      var s = void 0;
      t.channels.forEach(function (e) {
        if (e && 0 < e.length) {
          if ((e = e.sort(function (e, i) {
            return e.priority - i.priority;
          })).forEach(function (e) {
            e.priority < m && (s = e.identifier), e.initialize(t, n, o);
          }), s) throw Error(T + s);

          for (var i = 1; i < e.length; i++) {
            e[i - 1].setNextPlugin(e[i]);
          }

          r.channelQueue.push(e);
        }
      });
    }

    for (var e = new Array(), i = 0; i < o.length; i++) {
      var a = o[i];
      a.priority > m && e.push(a);
    }

    if (0 < e.length) {
      for ((e = e.sort(function (e, i) {
        return e.priority - i.priority;
      })).forEach(function (e) {
        return e.initialize(t, n, o);
      }), i = 1; i < e.length; i++) {
        e[i - 1].setNextPlugin(e[i]);
      }

      this.channelQueue.push(e);
    }
  }, x);

  function x() {
    this.identifier = "ChannelControllerPlugin", this.priority = m;
  }

  var v = "Extensions must provide callback to initialize",
      y = "Channels must be provided through config.channels only",
      m = 500,
      T = "Channel has invalid priority";
  a.MinChannelPriorty = 100, a.EventsDiscardedReason = i, a.AppInsightsCore = d, a.CoreUtils = f, a.NotificationManager = g, a.DiagnosticLogger = u, a._InternalLogMessage = l, a._InternalMessageId = s, Object.defineProperty(a, "__esModule", {
    value: !0
  });
});